module.exports = __webpack_public_path__ + "static/media/logout.d35ce88f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logout.svg
// module id = 646
// module chunks = 0